import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertService } from '../../services/alert.service';
import { CommunityService } from '../../services/community.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

declare var $: any;

@Component({
    selector: 'community-message',
    templateUrl: './community-message.component.html',
    styleUrls: ['./community-message.component.scss']
})
export class CommunityMessageComponent implements OnInit, OnDestroy {

    message: any;

    comments: any[] = [];

    count: number = 0;

    browseBeforeInProgress!: boolean;

    modalPhoto!: string | null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private communityService: CommunityService
    ) {
    }

    ngOnInit() {
        let messageId: any = this.route.snapshot.paramMap.get('messageId');
        this.progressIndicatorService.progress = true;
        this.communityService.getMessage(messageId).subscribe({
            next: (value: any) => {
                console.log('CommunityMessageComponent.ngOnInit.communityService.getMessage.value', value);
                this.progressIndicatorService.progress = false;
                this.message = value;
                this.refreshComments();
            },
            error: (error: any) => {
                console.log('CommunityMessageComponent.ngOnInit.communityService.getMessage.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    ngOnDestroy() {
    }

    updateUser(user: any) {
        if (this.message.user.id == user.id) {
            this.message.user.banned = user.banned;
        }
        for (let comment of this.comments) {
            if (comment.user.id == user.id) {
                comment.user.banned = user.banned;
            }
        }
    }

    navigateToCommunity() {
        this.router.navigate(['/community']);
    }

    refreshComments() {
        this.comments = [];
        this.count = 0;
        this.browseBefore();
    }

    browseBefore() {
        let messageId = this.message.id;
        let commentId = null;
        if (this.comments.length > 0) {
            commentId = this.comments[this.comments.length - 1].id;
        }
        this.browseBeforeInProgress = true;
        this.communityService.browseComments(messageId, commentId).subscribe({
            next: (value: any) => {
                console.log('CommunityMessageComponent.browseBefore.communityService.browseComments.value', value);
                this.browseBeforeInProgress = false;
                this.comments.push(...value.data);
                this.count = value.count - value.data.length;
                setTimeout(() => this.autoBrowseBefore(), 0);
            },
            error: (error: any) => {
                console.log('CommunityMessageComponent.browseBefore.communityService.browseComments.error', error);
                this.browseBeforeInProgress = false;
                this.alertService.danger('Error');
            }
        });
    }

    @HostListener('window:scroll', [])
    autoBrowseBefore() {
        if (this.count > 0 && !this.browseBeforeInProgress) {
            let documentHeight: number = $(document).height();
            let windowheight: number = $(window).height();
            let scrollTop: number = $(window).scrollTop();
            if (documentHeight - scrollTop < windowheight * 3) {
                this.browseBefore();
            }
        }
    }
}
